export class PriceAlertsEnvironment {
  public static getName = () => 'benzinga-price-alerts';
  public static getEnvironment = (env: Record<string, string>) => ({
    url: new URL(env.url ?? 'https://data-api-pro.zingbot.bz/rest/v1/'),
  });
}
